import * as React from "react";
import {ItemListRequest} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {EntityDataTable} from "../../list/EntityDataTable";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {ListUtils} from "../../list/ListUtils";
import {RouterView, LoadingViewState} from "../RouterView";
import {ItemService, ITEM_SERVICE_NAME} from "../../../service/admin/ItemService";
import {ColumnType} from "../../list/ColumnType";
import {ItemView} from "../../../../generated/protocol";
import {Form, FormListener} from "../../form/Form";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {createInitialState, ListView} from "../ListView";
import {SelectInput} from "../../form/SelectInput";
import * as _ from "lodash";
import {FeatureToggleService} from "../../../service/FeatureToggleService";


interface State extends LoadingViewState {
    listRequest?: ItemListRequest;
    form?: ItemListRequest;
    categories?: String[];
    validationMap?: any;
}

export class ItemListView extends ListView<State, ItemListRequest> implements FormListener<ItemListRequest> {
    columns = [
        {property: "imageUrl", name: "Image", orderBy: "imageUrl", type: ColumnType.IMAGE},
        {property: "name", name: "Name", orderBy: "name"},
        {property: "description", name: "Description", orderBy: "description"},
        {property: "category", name: "Category", orderBy: "category"},
        {property: "operatorId", name: "Operator", orderBy: "operatorId"},
        {property: "value", name: "Value", orderBy: "value"},
    ];
    actions = [
        {id: "view", name: "View", className: "btn btn-primary", iconClassName: "fa fa-eye"}
    ];

    itemService: ItemService;

    constructor(props) {
        super(props, "/item");
        this.itemService = AppCtx.resolve<ItemService>(ITEM_SERVICE_NAME);
        this.state.categories = ["ANY", "TICKET", "AVATAR", "JSNG_ENTRY"];
        this.state = createInitialState({limit: 50, orderBy: "name"}, this.state);
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    formDidUpdate(formModel: ItemListRequest, validationMap?: any) {
        this.setState({"form": formModel, validationMap: validationMap});
    }

    pagerChanged(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    onSubmitError(): void {

    };

    onSubmit(): void {
        let listRequest = _.clone(this.state.listRequest);
        listRequest.offset = 0;
        listRequest.orderBy = "name";
        listRequest.operatorId = this.state.form.operatorId;
        listRequest.category = this.state.form.category;
        listRequest.freeText = this.state.form.freeText;

        this.updateListState(listRequest);
    };


    onAction(item: ItemView, action: string) {
        if (action == "view") {
            this.navigate("/item/" + item.id);
        }
    }

    getTitle() {
        return "Items";
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated fadeInRight">

                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Filter Items</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="ibox-content">
                                <Form className="form-horizontal" formListener={this} modelObject={this.state.form}
                                      validationMap={this.state.validationMap}>
                                    <FormGroup className="form-group" model="category">
                                        <label className="col-lg-2 control-label">Category</label>
                                        <div className="col-lg-10">
                                            <SelectInput className="form-control" model="category"
                                                         values={this.state.categories}/>
                                            <span className="help-block m-b-none">Category.</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group" model="freeText">
                                        <label className="col-lg-2 control-label">Free Text</label>
                                        <div className="col-lg-10">
                                            <FormInput className="form-control" model="freeText" type="text"/>
                                            <span className="help-block m-b-none">Search items by name id, name or description.</span>
                                        </div>
                                    </FormGroup>

                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <input className="btn btn-primary" value="List Items" type="submit"/>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>

                    <EntityDataTable service={this.itemService} onPagerChange={this.pagerChanged.bind(this)}
                                     columns={this.columns} listRequest={this.state.listRequest}
                                     onAction={this.onAction.bind(this)} actions={this.actions}/>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/item/ItemListView.tsx